import type { ReactNode } from 'react';
import type { ReviewHolder } from './review-leases';

/** The small "who has this" mark on a spine document another reviewer holds (ADR-0009): initials and a first name. */
export function HeldByChip({ holder }: { holder: ReviewHolder }): ReactNode {
  const words = holder.name.trim().split(/\s+/).filter(Boolean);
  const initials = words
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
  return (
    <span className="paige-held-by" title={`${holder.name} is reviewing this`}>
      <i aria-hidden="true">{initials || '?'}</i>
      <span>{words[0] ?? holder.name}</span>
    </span>
  );
}
